//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfBreadcrumbs, SfButton } from '@storefront-ui/vue';
import ContentPages from '@/components/ContentPages/ContentPages.vue'
import { computed, useRoute, useRouter, ref, onMounted } from '@nuxtjs/composition-api';
import { useUser } from '@bee-hole/coms';
import MyProfile from './MyAccount/MyProfile';
import ShippingDetails from './MyAccount/ShippingDetails';
import BillingDetails from './MyAccount/BillingDetails';
import MyNewsletter from './MyAccount/MyNewsletter';
import MyWishList from './MyAccount/MyWishList';
import OrderHistory from './MyAccount/OrderHistory';
import DistributorDetails from './MyAccount/DistributorDetails';
import { useUiState } from '~/composables';
export default {
  name: 'MyAccount',
  components: {
    SfBreadcrumbs,
    MyProfile,
    ShippingDetails,
    BillingDetails,
    MyNewsletter,
    MyWishList,
    OrderHistory,
    SfButton,
    ContentPages,
    DistributorDetails
  },
  middleware: [
    'is-authenticated'
  ],
  setup(props, context) {
    const route = useRoute();
    const router = useRouter();
    const { logout } = useUser();
    const { isMobile } = useUiState();
    const list = ref([]);
    const theme = ref('');
    onMounted(() => {
      list.value = [{
        text: context?.root?.$t('Home'),
        route: { link: context.root.localePath("/") },
        link: context.root.localePath("/")
      },
      {
        text: context?.root?.$t('MyAccount'),
        route: { link: '#' },
        link: '#'
      }];
    });
    const activePage = computed(() => {
      const { pageName } = route.value.params;
      if (pageName) {
        return (pageName.charAt(0).toUpperCase() + pageName.slice(1)).replace('-', ' ');
      } else if (!isMobile.value) {
        return 'My profile';
      } else {
        return '';
      }
    });

    const changeActivePage = async (title) => {
      if (title === 'Log_out') {
        await logout();
        router.push(context.root.localePath({ name: 'home' }));
        return;
      }

      const slugifiedTitle = (title || '')?.toLowerCase()?.replace(' ', '-');
      let transformedPath = `/my-account/${slugifiedTitle}`;
      if (slugifiedTitle === context.root.$t('MyAccount_History')) {
        transformedPath += '?open=1';
      }
      const localeTransformedPath = context.root.localePath(transformedPath);
      router.push(localeTransformedPath);
    };

    const changeTheme = () => {
      const themes = ['blue', 'yellow', 'red'];
      let i = themes.indexOf(theme.value);
      // if (theme.value === 'blue') {
      //   theme.value = 'dark';
      // } else {
      //   theme.value = 'light';
      // }
      i += 1;
      if (i === -1) {
        i = 0;
      } else if (i >= themes.length) {
        i = 0;
      }
      theme.value = themes[i];
      // window.document.documentElement.setAttribute('data-theme', theme.value);
      window.document.documentElement.setAttribute('class', theme.value);
    };
    return {
      changeActivePage,
      activePage,
      changeTheme,
      theme,
      Breadcrumbs: list
    };
  }
};
